export interface StateLicense {
  state: string;
  licenseNumber: string;
  status: LicenseStatus;
}

export enum LicenseStatus {
  Inactive = 'Inactive',
  Registered = 'Registered',
}
